import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'night_wake_ups'

const OPTIONS = [
  {
    value: 'none',
    translationKey: 'pages.onboarding.nightWakeUps.options.none',
  },
  {
    value: 'once',
    translationKey: 'pages.onboarding.nightWakeUps.options.once',
  },
  {
    value: 'two-to-three',
    translationKey: 'pages.onboarding.nightWakeUps.options.twoToThree',
  },
  {
    value: 'four-plus',
    translationKey: 'pages.onboarding.nightWakeUps.options.fourPlus',
  },
]

const answers: AnswerType[] = [
  {
    emoji: '😴',
    title: 'pages.onboarding.nightWakeUps.options.none',
    value: 'none',
  },
  {
    emoji: '🌙',
    title: 'pages.onboarding.nightWakeUps.options.once',
    value: 'once',
  },
  {
    emoji: '⏰',
    title: 'pages.onboarding.nightWakeUps.options.twoToThree',
    value: 'two-to-three',
  },
  {
    emoji: '🫨',
    title: 'pages.onboarding.nightWakeUps.options.fourPlus',
    value: 'four-plus',
  },
]

export default function NightWakeUpsPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const answerValue = input.value

    if (!answerValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How many times do you usually wake up during the night?',
      answer_key: answerValue,
      answer: answerValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.nightWakeUps.heading"
      onSubmit={onSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
